document.addEventListener('DOMContentLoaded', function () {
  const nav = document.querySelector('.collection-navigation');
  if (!nav) return;


  const links = nav.querySelectorAll('a');
  const currentUrl = window.location.href;

  links.forEach(link => {
    const submenu = link.nextElementSibling;

    if (submenu && submenu.classList.contains('collection-navigation-lvl-2')) {
      link.classList.add('has-children');


      const arrow = document.createElement('span');
      arrow.className = 'arrow';
      arrow.innerHTML = `
        <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="1.00015" y1="1" x2="5.24279" y2="5.24264" stroke="#373737" stroke-width="2" stroke-linecap="round"/>
          <line x1="5.58594" y1="5.24204" x2="9.82858" y2="0.999396" stroke="#373737" stroke-width="2" stroke-linecap="round"/>
        </svg>
      `;

      link.appendChild(arrow);

      link.addEventListener('click', function (event) {
        event.preventDefault();
        submenu.classList.toggle('visible');
        arrow.classList.toggle('open');
      });
    }
  });

  links.forEach(link => {
    if (link.href === currentUrl) {
      link.classList.add('active');

      // Check if this link is inside a submenu
      const parentSubmenu = link.closest('.collection-navigation-lvl-2');

      if (parentSubmenu) {
        parentSubmenu.classList.add('visible');

        // Find the parent link that controls this submenu
        const parentLink = parentSubmenu.previousElementSibling;

        if (parentLink) {
          const arrow = parentLink.querySelector('.arrow');
          if (arrow) {
            arrow.classList.add('open');
          }
        }
      }
    }
  });
});

let sidebar = document.querySelector(".collection-navigation");
if (sidebar) {
  let scrollPosition = sessionStorage.getItem("sidebarScroll");
  if (scrollPosition) {
    sidebar.scrollTop = scrollPosition;
  }
  sidebar.addEventListener("scroll", function () {
    sessionStorage.setItem("sidebarScroll", sidebar.scrollTop);
  });
}
